import type { FC } from 'react';

import type { UserAvatarProps } from './UserProfileCard.types';
import { AVATAR_SIZE_MAP, getGradientForName, getInitials, STATUS_SIZE_MAP } from './utils';

export const UserAvatar: FC<UserAvatarProps> = ({ name, size = 'medium', status, imageUrl, className = '' }) => {
	const initials = getInitials(name);
	const gradient = getGradientForName(name);
	const avatarSize = AVATAR_SIZE_MAP[size];
	const statusSize = STATUS_SIZE_MAP[size];

	const fontSize = size === 'small' ? 12 : size === 'medium' ? 14 : 16;

	return (
		<div
			className={`user-avatar user-avatar--${size} ${className}`}
			style={
				{
					'--avatar-size': `${avatarSize}px`,
					'--status-size': `${statusSize}px`,
					'--avatar-font-size': `${fontSize}px`,
				} as React.CSSProperties
			}
		>
			<div
				className='user-avatar__container'
				style={{
					background: imageUrl ? `url(${imageUrl}) center/cover` : gradient,
				}}
			>
				{!imageUrl && <span className='user-avatar__initials'>{initials}</span>}
			</div>

			{status && (
				<span
					className={`user-avatar__status user-avatar__status--${status}`}
					aria-label={`Status: ${status}`}
				/>
			)}
		</div>
	);
};

export default UserAvatar;
